import { useEffect, useRef } from 'react';

/**
 * Hook that runs a callback after a delay when its returning function is called
 * @returns Function that can be called to run the callback after the delay has passed
 */
export const useSetTimeout = () => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleCallback = (callback: () => void, delay: number) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(callback, delay);
  };

  useEffect(() => () => {
    // Clear timeout, if set, on unmount
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return handleCallback;
};
export default useSetTimeout;
